<template>
    <div class="od-mono-pill">
        <span class="od-mono-pill__value od-mono">{{ value }}</span>
        <od-copy-button :value="value" />
    </div>
</template>

<script>
import OdCopyButton from './OdCopyButton.vue';

export default {
    name: 'OdMonoPill',
    components: { OdCopyButton },
    props: {
        value: { type: String, required: true },
    },
};
</script>
